import React from "react";

const MobiControl = () => {

    return (
        <div id="mobicontrol">
            <h3>MobiControl</h3>

            <div className="imageContainer">
                <img src="/images/mobicontrol.png" alt="Mobicontrol" />
            </div>

            <p>
                <strong>MobiControl blocks</strong> allow you to retrieve detailed device information and interact with system-level data. These blocks are useful for enterprise apps, diagnostics, and dynamic configuration based on device context.
            </p>

            <h4>Android Device Info</h4>
            <p>
                The <strong>get Android device details by category</strong> block lets you retrieve specific information about the device. It returns the value of the specified key. You can choose from the following categories:
            </p>
            <ul>
                <li><strong>device info</strong></li>
                <li><strong>memory info</strong></li>
                <li><strong>hardware info</strong></li>
                <li><strong>support info</strong></li>
                <li><strong>telephony info</strong></li>
                <li><strong>network info</strong></li>
            </ul>

            <h4>General Device Info</h4>
            <p>
                These blocks retrieve specific attributes from the device:
            </p>
            <ul>
                <li><strong>get custom value by key</strong> – Returns a custom attribute value.</li>
                <br />
                <li><strong>get device enrolled state</strong> – Returns whether the device is enrolled in MobiControl.</li>
                <br />
                <li><strong>get device ID</strong> – Returns the unique device identifier.</li>
                <br />
                <li><strong>get device IP address</strong> – Returns the current IP address.</li>
                <br />
                <li><strong>get device MAC address</strong> – Returns the MAC address of the device.</li>
                <br />
                <li><strong>get device serial number</strong> – Returns the serial number of the device.</li>
            </ul>

            <h4>iOS Device Info</h4>
            <p>
                The <strong>get iOS device details by key</strong> block allows you to retrieve specific information from iOS devices using a key.
            </p>

            <p>
                All these blocks include an <strong>on success</strong> hook, which allows you to execute code after successfully retrieving a value.
            </p>
        </div>
    )
}

export default MobiControl;
